<app-personlist
    *ngIf="request && request.dossierPersons && request.dossierPersons.length > 0 || (workflowData && workflowData.placeholders && workflowData.placeholders.length > 0)"
    [request]="request" [showAddMyself]="showAddMyself()" [showMessage]="showMessage"
    [sortingAllowed]="!workflowData || workflowData.allowSorting" [placeholders]="workflowData?.placeholders"
    [step1placeholders]="step1placeholders" [allowAddPersons]="workflowData?.allowAddPersons"
    (PersonUpdated)="PersonUpdated($event)" (PersonRemoved)="RemovePerson($event)"
    (PersonChangeOrder)="PersonChangeOrder($event)" (addMyself)="addMyself($event)" (addPerson)="addPerson($event)"
    (updatePersonProgress)="triggerUpdatePersonProgress()">
</app-personlist>
<app-addpersonzone class="d-lg-none" [showAddMyself]="showAddMyself()"
    [dossierPersonsAmount]="request.dossierPersons ? request.dossierPersons.length : 0"
    [maxPersonAmount]="workflowData?.maxPersonAmount" (addMyself)="addMyself()" (addPerson)="addPerson()">
</app-addpersonzone>
<app-addpersonzone class="d-none d-lg-block"
    *ngIf="!workflowData || !workflowData.placeholders || workflowData.placeholders.length===0 || workflowData?.allowAddPersons"
    [showAddMyself]="showAddMyself()"
    [dossierPersonsAmount]="request.dossierPersons ? request.dossierPersons.length : 0"
    [maxPersonAmount]="workflowData?.maxPersonAmount" (addMyself)="addMyself()" (addPerson)="addPerson()">
</app-addpersonzone>